import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './styles/theme';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
// import FactCheckChatbot from './components/FactCheckChatbot'; // Replaced with widget

// Pages
import Home from './pages/Home';
import Category from './pages/CategoryPage';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Post from './pages/Post';
import About from './pages/About';
import Contact from './pages/Contact';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';

// Auth context
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/:slug" element={<Category />} />

                <Route path="/sign-in" element={<SignIn />} />
                <Route path="/signin" element={<Navigate to="/sign-in" replace />} />
                <Route path="/login" element={<Navigate to="/sign-in" replace />} />
                <Route path="/sign-up" element={<SignUp />} />
                <Route path="/signup" element={<Navigate to="/sign-up" replace />} />
                <Route path="/register" element={<Navigate to="/sign-up" replace />} />
                <Route path="/post/:id" element={<Post />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />
                <Route path="/legal" element={<Navigate to="/terms" replace />} />
                <Route path="/disclaimer" element={<Navigate to="/terms" replace />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            {/* FactCheckChatbot removed - replaced with FactCheckWidget in sidebar */}
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
